import React from 'react';
import './DeleteTaskForm.scss';
import { closeDeleteGroupTaskForm, deleteGroupTask } from '../../../MainVIew/Tasks/taskSlice';


const DeleteGroupTaskForm = (props) => {
    const { dispatch } = props;
 // CLICK OK
 
 const onSend = () => {
      
    console.log('Start delete group task action');

        const data = {
            taskId: props.taskId,
            
        }

       dispatch(deleteGroupTask(data));
       
    
       dispatch(closeDeleteGroupTaskForm());
       props.onClickClear();
    }
    

    // CLOSE FORM
    const onClose = () => {
        const { dispatch } = props;
       
    dispatch(closeDeleteGroupTaskForm());
    

    }


    const render = () => {

        
            return(
                <div className="DeleteTaskForm">
                    
                <p><b>Вы действительно хотите удалить группу пользователей?</b></p>
                
                <button onClick={onSend}>Да</button>
                <button onClick={onClose}>Отмена</button>
                </div>
            )
       
   
    }
return render();
}
export default DeleteGroupTaskForm;
  